/**
 *  CollapsibleTagList script file
**/
import i18n from '@/i18n'

export default {
  name: 'CollapsibleTagList',
  mixins: [],
  components: {},
  props: {
    backgroundColor: {
      type: String,
      default: 'var(--colorPrimary)'
    },
    positive: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      required: true
    },
    displayProp: {
      type: String,
      default: 'label'
    },
    idProp: {
      type: String,
      default: 'id'
    },
    limit: {
      type: Number,
      default: 5
    },
    tagType: {
      type: String,
      default: 'info-rounded'
    },
    active: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      expanded: false
    }
  },
  computed: {
    expandLabel () {
      return this.expanded ? i18n.t('COLLAPSE') : i18n.t('SEE_ALL_2')
    },
    filteredList () {
      return this.expanded ? this.list : this.list.slice(0, this.limit)
    }
  },
  methods: {
    toggle () {
      this.expanded = !this.expanded
    }
  }
}
